<template>
    <div class="wrapper">
        <div class="section section-blogs-2 topsearch">
            <div class="container main">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-size-100 md-small-size-100 mx-auto"
                    >
                        <router-link
                            :to="{
                                name: 'calcdictGroupData',
                                params: { dictCode: dictCode, page: page },
                            }"
                            id="buttonback"
                        >
                            <md-icon>keyboard_arrow_left</md-icon>
                            Назад к списку справочников
                        </router-link>
                    </div>
                    <div
                        class="md-layout-item md-size-100 md-small-size-100 mx-auto"
                    >
                        <div class="name">
                            <h3 class="title">
                                Добавление неквалифицированного лида
                            </h3>
                            <div
                                class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep"
                            >
                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field>
                                        <label>{{
                                            mapElementName['region']
                                        }}</label>
                                        <md-select
                                            v-model="source"
                                            md-dense
                                            name="source"
                                        >
                                            <md-option
                                                v-for="item of sources"
                                                :value="item.id"
                                                >{{ item.name }}
                                            </md-option>
                                        </md-select>
                                    </md-field>
                                </div>
                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field>
                                        <label>Имя</label>
                                        <md-input
                                            type="text"
                                            v-model="name"
                                        ></md-input>
                                    </md-field>
                                </div>
                                <!--div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
                                    <md-field>
                                        <label>LocationId</label>
                                        <md-input type="text" v-model="locId"></md-input>
                                    </md-field>
                                </div-->
                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field>
                                        <label>Телефон</label>
                                        <md-input
                                            type="text"
                                            v-model="phone"
                                        ></md-input>
                                    </md-field>
                                </div>
                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field>
                                        <label>Комментарий</label>
                                        <md-input
                                            type="text"
                                            v-model="comment"
                                        ></md-input>
                                    </md-field>
                                </div>
                            </div>
                            <div id="captcha-container"></div>
                            <br />
                            <div
                                class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep"
                            >
                                <template>
                                    <md-button
                                        @click="sendForm()"
                                        class="md-button md-success md-theme-default"
                                        v-if="action !== 'delete'"
                                    >
                                        Отправить
                                    </md-button>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { checkAuthentication, reAuthenticate } from '@/utils/auth-api';
import { required } from 'vuelidate/lib/validators';
import {
    saveItem,
    addLead,
    deleteItem,
    calcdictGroupData,
} from '@/utils/dict-api';

export default {
    mixins: [validationMixin],
    components: {},
    bodyClass: 'dictionary-data',
    props: ['page', 'action'],
    data() {
        return {
            sources: [
                {
                    id: 'unqualified_form',
                    name: 'Форма обратной связи',
                },
                {
                    id: 'unqualified_vk',
                    name: 'VK',
                },
                {
                    id: 'unqualified_facebook',
                    name: 'Facebook',
                },
                {
                    id: 'unqualified_instagram',
                    name: 'Instagram',
                },
                {
                    id: 'unqualified_repeat',
                    name: 'Повторное обращение',
                },
                {
                    id: 'unqualified_hotline',
                    name: 'Заявка с горячей линии',
                },
            ],
            comment: '',
            options: [],
            dictCode: this.$route.params.code,
            code: this.$route.params.code,
            calcDictData: [],
            dictionaryId: '',
            selectedDataId: this.$route.params.id,
            selectedData: null,
            source: 'unqualified_form',
            name: '',
            phone: '',
            locId: 1,
            form: {
                action: 'save',
                dictCode: this.$route.params.code,
                id: '',
                valOrder: '',
                value: '',
                valueId: '',
            },
            mapElementName: {
                valOrder: 'Порядок отображения',
                value: 'Название',
                valueId: 'Значение',
                id: 'ID',
            },
            captchaId: '',
        };
    },
    validations: {
        form: {
            value: {
                required,
            },
            valueId: {
                required,
            },
            valOrder: {
                required,
            },
        },
    },
    watch: {},
    methods: {
        async sendForm() {
            if (window.smartCaptcha) {
                window.smartCaptcha.execute(this.captchaId);
                return;
            }
            await this.addLead();
        },
        addLead(captchaToken) {
            if (!this.name.trim()) {
                alert('Введите имя');
            } else if (!this.phone.trim()) {
                alert('Введите телефон');
            } else {
                addLead(
                    {
                        sourceName: this.source,
                        name: this.name,
                        phone: this.phone,
                        locId: this.locId,
                        comment: this.comment,
                        utm: 'unqualified',
                    },
                    captchaToken
                )
                    .then(result => {
                        alert('Лид успешно добавлен.');
                        this.name = '';
                        this.phone = '';
                        this.comment = '';
                    })
                    .catch(error => {
                        alert('error');
                    });
            }
        },
        getValidationClass(fieldName) {
            const field = this.$v.form[fieldName];
            if (field) {
                return {
                    'md-invalid': field.$invalid && field.$dirty,
                };
            }
        },
        validateData(sendFn) {
            this.$v.form.$touch();
            if (!this.$v.form.$invalid) {
                sendFn();
            }
        },
        setData: function(data) {
            this.form = data;
        },
        getElementData: function() {
            if (this.selectedDataId === 'new') {
                this.addItem();
                return;
            }
            checkAuthentication(this.$router, this.$route).then(response => {
                // получаем все, фильтруем по id
                calcdictGroupData(this.code)
                    .then(result => {
                        if (result) {
                            this.calcDictData = result;
                            var that = this;
                            this.calcDictData.forEach(function(item) {
                                if (item.id == that.selectedDataId) {
                                    that.setData(item);
                                }
                            });
                        }
                    })
                    .catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
            });
        },
        addItem: function() {
            const item = {
                id: 'new',
                value: '',
                valOrder: '',
                valueId: '',
            };

            this.setData(item);
        },
        deleteItem: function() {
            checkAuthentication(this.$router, this.$route).then(response => {
                deleteItem(
                    'dict',
                    JSON.stringify({ id: this.$route.params.id })
                )
                    .then(result => {
                        this.$router.push({
                            name: 'calcdictGroupData',
                            params: { code: this.dictCode },
                        });
                    })
                    .catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
            });
        },
        saveItem: function() {
            if (this.form.id === 'new') {
                this.form.id = null;
            }
            this.form.dictCode = this.dictCode;
            saveItem('dict', JSON.stringify(this.form))
                .then(result => {
                    this.$router.push({
                        name: 'calcdictGroupData',
                        params: { dictCode: this.dictCode },
                    });
                })
                .catch(error => {
                    reAuthenticate(this.$router, this.$route, error);
                });
        },
        checkEditableNames: function(name) {
            const editableNames = ['valueId', 'value', 'order'];
            return editableNames.indexOf(name) >= 0;
        },
    },
    created() {
        if (this.$route.params.action == 'delete') {
            // this.deleteItem()
        } else {
            // this.getElementData()
        }
    },
    mounted() {
        const timer = setInterval(() => {
            if (!window.smartCaptcha) return;

            this.captchaId = window.smartCaptcha.render('captcha-container', {
                sitekey:
                    'ysc1_RwHi6GjloYmNsyuuBdpnDnpd0kjKAjZdfoupwDsnd6edf87b',
                invisible: true,
                hl: 'ru',
                callback: token => {
                    this.addLead(token);
                },
            });
            clearInterval(timer);
        }, 500);
    },
};
</script>

<style lang="scss" scoped type="text/scss">
.dictionary-data .md-field {
    padding-top: 16px;
    margin: 4px 0 24px;
}

.offset-left-16 {
    margin-left: 16px;
}
</style>
